module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABEUlEQVQ4T82UsWoCURBFz0DKFJYBLVL4CZaBWFhYaBfBwhR+SiB2FkJ+QNAuTfoUEdLmA1IIWgaSIhALIYErs+ziZtW4riKZ5u0ud8+7M2/eGGFIygN9oAycRN93WF+BpsWAz8DFDoCkdAx8BEBJp8DXHrAXoAPcR8BzYLIHcATcAE+HAnr93GVrHXAOdIGfLY5LQC2heVsHnIbC2RbgVbixy/pm1vaHQ6V8XKCnXAfiKXuj3wHVDWX40+GmQ2kBxSzALO143Br+M4eSLgHver8dWWNZQ0nfGedffPMVYMPMHtLYk+Q9+Q7kYvpfwEegkHIgRIzb8J/o/drMhsFdlnQGDIBKGocJzSfQMzOfhUEsAHz7e9kFN3PaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/dsds.png
// module id = 4FHd
// module chunks = 2